import {formatISOByGuard} from '@shared/helpers/date'

import {initDetailByAPI} from '@web/actions/detail'
import makeSlice from '@web/slices/recommendationProduct/sliceMaker'

const recommendationProductSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload: {data}}) => {
            state.products = data.productOrders.map((product) => {
                return {
                    ecNvMid: product.ecNvMid ?? undefined,
                    orderDateTime: formatISOByGuard(product.payDateTime) ?? undefined,
                    productOrderStatus: product.productOrderStatusType ?? undefined,
                    productPaymentAmount: product.orderAmount ?? undefined,
                    productCategoryId: product.productCategoryId ?? undefined,
                }
            })
        })
    },
})

export default recommendationProductSlice.reducer
